var _path, _path2;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserIconRed(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "#00ff00",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00342 6.49281C7.83167 6.49281 9.31376 5.03936 9.31376 3.24644C9.31376 1.45351 7.83167 6.10352e-05 6.00342 6.10352e-05C4.17517 6.10352e-05 2.69307 1.45351 2.69307 3.24644C2.69307 5.03936 4.17517 6.49281 6.00342 6.49281Z",
    fill: "#ff0a00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00342 8.116C2.68971 8.116 0.00341797 10.7504 0.00341797 14.0001H12.0034C12.0034 10.7504 9.31713 8.116 6.00342 8.116Z",
    fill: "#ff0a00"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIconRed);
export default __webpack_public_path__ + "static/media/user-icon-red.b4474b7e.svg";
export { ForwardRef as ReactComponent };